import React, { Component } from "react";
import TournamentCardComponent from "../../Tournaments/TournamentCardComponent";
import loadinggif from "../../../assets/images/loading.gif";
import NotFoundContainer from "../../../containers/NotFoundContainer";

class HostChallengesLiveViewAllComponent extends Component {
  componentDidMount() {
    this.props.invalidateBrandDetailsDetails();
    this.props.fetchBrandDetailsIfNeeded({
      brandId: this.props.match.params.id,
      profileId: this.props.userId
    });

    const {
      fetchHostChallengesLiveViewAllIfNeeded,
      invalidateAllHostChallengesLiveViewAll,
      page
    } = this.props;
    invalidateAllHostChallengesLiveViewAll();
    fetchHostChallengesLiveViewAllIfNeeded({
      // profileId: this.props.userId,
      brandId: this.props.match.params.id,
      page: page
    });
  }

  componentDidUpdate() {
    document.body.classList.remove("modal-open");
  }

  render() {
    const { hostChallengesLiveList, brandDetails, page } = this.props;

    
    if (hostChallengesLiveList.isFetching) {
      return (
        <div className="text-center">
          <div className="col-sm-12">
            <img src={loadinggif} alt="" />
          </div>
        </div>
      );
    }
    if (!(hostChallengesLiveList.items.length > 0)) {
      return <NotFoundContainer />;
    }
    if (
      hostChallengesLiveList &&
      brandDetails &&
      brandDetails.item &&
      hostChallengesLiveList.items
    ) {
      return (
        <section className="container-fluid my-tournament-wrapper">
          <div className="row">
            <div className="container">
              <div className="padder-main">
                <div className="row d-flex align-items-center mb-30 ">
                  <div className="col-8 d-flex justify-content-start">
                    <h2 className="bold">
                      {brandDetails.item.name}'s Tournaments
                    </h2>
                  </div>
                </div>

                <div className="row card-wrapper d-flex justify-content-center justify-content-sm-start">
                  {this.props.hostChallengesLiveList.items.length > 0
                    ? this.props.hostChallengesLiveList.items.map(
                        (tournament, i) => (
                          <div className="col-auto mb-4" key={i}>
                            <TournamentCardComponent
                              {...tournament}
                              cardClass="card card-my-tournament"
                              brandAvatarClass="profile-pic-56"
                              challengeType="Live"
                              order={i+1}
                            />
                          </div>
                        )
                      )
                    : ""}
                </div>
                <div className="row mb-30 text-center">
                  <div className="col-sm-12">
                    {this.props.hostChallengesLiveList.items.length > 0 ? (
                      !this.props.hostChallengesLiveList.isLastPage ? (
                        <button
                          onClick={() => {
                            this.props.invalidateHostChallengesLiveViewAll();
                            this.props.fetchHostChallengesLiveViewAllIfNeeded({
                              //profileId: this.props.userId,
                              brandId: this.props.match.params.id,
                              page: page
                            });
                          }}
                          className="btn btn-pink dark btn-xs"
                        >
                          Load More
                        </button>
                      ) : this.props.hostChallengesLiveList.isFetching ? (
                        <img src={loadinggif} alt="" />
                      ) : (
                        ""
                      )
                    ) : this.props.hostChallengesLiveList.isFetching ? (
                      <img className="text-center" src={loadinggif} alt="" />
                    ) : (
                      <span>No Tournament Found</span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      );
    } else {
      return <></>;
    }
  }
}

export default HostChallengesLiveViewAllComponent;
